import React, { useState, useEffect } from 'react';
import axios from 'axios';
import axiosInstance from '../../../axiosInstance'; import { Link, useNavigate, useParams } from 'react-router-dom';
import Sidebar from '../../components/Sidebar';
import Navbar from '../../components/Navbar';
import toast from 'react-hot-toast';
import { Button } from 'bootstrap/dist/js/bootstrap.bundle.min';
import { event } from 'jquery';
import getDecryptData from '../../../helpers/getDecryptData';
import Select from 'react-select';

const LeadEditShort = () => {
  const navigate = useNavigate();
  const [Lpro, setLPro] = useState([]);

      const fetchData = async () => {
      try {
         const response = await axiosInstance.get(
          `/admin/all-lead-product-fillter?page=1&limit=1000000&search=`
        );
        setLPro(response.data.Department);
       
       } catch (error) {
        setLPro([])
       } 
    };
  
    useEffect(() => {
      fetchData();
    }, []);
  


  const [AllProducts, setAllProducts] = useState([]);

  const getUserAllPro = async () => {
    try {
        const response = await axiosInstance.get(`/all-products?type=1`);

        setAllProducts(response.data.products);
        console.log('setAllProducts', response.data.products)

    } catch (error) {
        console.error('Error fetching user products:', error);
    } 
};



  const [AllUser, setAllUser] = useState([]);
  const [AddProduct, setAddProduct] = useState([]);

  const [AddRental, setAddRental] = useState([]);
  const [AddReceived, setAddReceived] = useState([]);
  const [AddReturn, setAddReturn] = useState([]);
  const [addHistory, setAddHistory] = useState([]);
  const [OldHistory, setOldHistory] = useState({});

  


  const [UserId, setUserId] = useState(null);
  const [AllEmployee, setAllEmployee] = useState([]);

  const [AllSaleEmployee, setAllSaleEmployee] = useState([]);


  const [UserDetails, setUserDetails] = useState({});

  
  const [OrderId, setOrderId] = useState(null);


  // Utility function to convert ISO date string to YYYY-MM-DD format
const formatDate = (isoDateString) => {
  const dateObj = new Date(isoDateString);

  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
  const day = String(dateObj.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};

    const [formData, setFormData] = useState({
          PickupDate: '',
    ReturnDate: ''
    });
  
    const [subtotal, setSubtotal] = useState(0);
    const [discount, setDiscount] = useState(0); // Default discount is 0
    const [shipping, setShipping] = useState(0); // Default discount is 0
    const [finalTotal, setFinalTotal] = useState(0);
    const [taxTotal, setTaxTotal] = useState(0);

    const [applyIGST, setApplyIGST] = useState(false);
    const [applyCGST, setApplyCGST] = useState(false);
    const [applySGST, setApplySGST] = useState(false);

    const handleClearClick = () => {
      setSearchQuery("");
    };

    const handleDiscountChange = (e) => {
      const value = parseFloat(e.target.value) || 0;
      setDiscount(value);
    };

    const handleShippingChange = (e) => {
      const value = parseFloat(e.target.value) || 0;
      setShipping(value);
    };
    
    const handleAddProduct = (product) => {
      const now = new Date();
      const timeStamp = now.toISOString(); // e.g., 2025-05-01T10:10:30.000Z

      if (formData.order  === 1 && product.stock <= 0) {
        toast.error('Product is out of stock');
        return null;  // Early return to prevent adding the product
      }else if( product.reStock <= 0){
                    toast.error('Product is out of stock');
                    return null;  
                  }

       console.log('ProductProduct',product.reStock)
      let ProductCost = 0;
      // if(formData.diffDays && formData.diffDays > 0){
      //  if(formData.diffDays < 8){
      //   ProductCost = product.oneto7 ? product.oneto7 : product.salePrice ;
      //  }else if(formData.diffDays < 15){
      //   ProductCost = product.eightto14 ? product.eightto14 : product.salePrice ;
      //  }else if(formData.diffDays < 30){
      //   ProductCost = product.fivto30 ? product.fivto30 : product.salePrice ;
      //  }else if(formData.diffDays < 90){
      //   ProductCost = product.monthto3month ? product.monthto3month : product.salePrice ;
      //  }else if(formData.diffDays < 180){
      //   ProductCost = product.threemonthto6month ? product.threemonthto6month : product.salePrice ;
      //  }else{
      //   ProductCost = product.salePrice;
      //  }
      //  ProductCost = formData.diffDays * ProductCost;
      // }
      console.log('ProductCost',ProductCost);
      console.log('formData.diffDays',formData.diffDays);

      const updatedProduct = {
        ...product,
        quantity: 1,
        amount: ProductCost,
        total: ProductCost,
        history : timeStamp,
        tax: id === '1' ? product.gst : product.Rentalgst || 0 ,
       };
      setAddProduct([...AddProduct, updatedProduct]);
      SubmitHistory(`Add Product`, `product : ${product.title}`)

      setSearchQuery("");
      console.log('Rentaltax')
    };

    
      const handleAddRental = () => {
        const now = new Date();
        const timeStamp = now.toISOString(); // e.g., 2025-05-01T10:10:30.000Z 
        
              if( !formData.raMethod ){
            
              if(!formData.raDate){
                toast.error('Date is required')
              } else if(!formData.raTime){
                toast.error('Time is required')
              }else if(!formData.raAmount){
                toast.error('Amount is required')
              } else if(!formData.raMethod){
                toast.error('Payment method is required')
              }
            return null;
            }
              const updatedData = {
                date: formData.raDate,
                time: formData.raTime,
                gateway: formData.raGateway,
                amount: formData.raAmount,
                method: formData.raMethod,
                transaction: formData.raTransaction,
                comment: formData.raComment,
                checkNo: formData.raCheckNo,
                bankName: formData.raBankName,
                chequeAmount: formData.raChequeAmount,
                chequeDate: formData.raChequeDate,  
                authSignatoryName: formData.raAuthSignatoryName,
                history : timeStamp,
              };
        
              setAddRental([...AddRental, updatedData]);
              setFormData((prevData) => ({
                ...prevData,
                raDate: '',
                raTime: '',
                raGateway: '',
                raAmount: '',
                raMethod: '',
                raTransaction: '',
                raComment: '',
                raCheckNo: '',
                raBankName: '',
                raChequeAmount: '',
                raChequeDate: '',
                raAuthSignatoryName: '',
              }));
              SubmitHistory('Add Rental', 'None')

            }
        
            const handleAddReceived = () => {
              if( !formData.raMethod ){
            
              if(!formData.raDate){
                toast.error('Date is required')
              } else if(!formData.raTime){
                toast.error('Time is required')
              }else if(!formData.raAmount){
                toast.error('Amount is required')
              }else if(!formData.raMethod){
                toast.error('Payment method is required')
              }
            return null;
            }
              const updatedData = {
                days: formData.days || 'NA',
                date: formData.raDate,
                time: formData.raTime,
                gateway: formData.raGateway,
                amount: formData.raAmount,
                method: formData.raMethod,
                transaction: formData.raTransaction,
                comment: formData.raComment,
                checkNo: formData.raCheckNo,
                bankName: formData.raBankName,
                chequeAmount: formData.raChequeAmount,
                chequeDate: formData.raChequeDate,  
                authSignatoryName: formData.raAuthSignatoryName,
              };

              if (formData.days) {
  const pickupDate = new Date(formData.PickupDate);
  const returnDate = new Date(formData.ReturnDate);
  const diffTime = returnDate - pickupDate;
  const diffDays = diffTime / (1000 * 3600 * 24);

  const extraDays = Number(formData.days);
  const totalDays = diffDays + extraDays + 1;

  console.log('Base diffDays: ' + diffDays);
  console.log('Extra days: ' + extraDays);
  console.log('Total days: ' + totalDays);

  const returnValue = addDaysToDate(formData.PickupDate, totalDays);

  setFormData((prevData) => ({
    ...prevData,
    ReturnDate: returnValue,
    diffDays: totalDays,
  }));

  toast.error('Updated ReturnDate: ' + returnValue);
}


              setAddReceived([...AddReceived, updatedData]);
              setFormData((prevData) => ({
                ...prevData,
                raDate: '',
                raTime: '',
                raGateway: '',
                raAmount: '',
                raMethod: '',
                raTransaction: '',
                raComment: '',
                raCheckNo: '',
                raBankName: '',
                raChequeAmount: '',
                raChequeDate: '',
                raAuthSignatoryName: '',
              }));
              SubmitHistory(formData.order === 4 ? 'Add Payment Mangement' : 'Add Security Amount Received'  , 'None')

            }
        
            const handleAddReturn = () => {
              if( !formData.raMethod ){
            
              if(!formData.raDate){
                toast.error('Date is required')
              } else if(!formData.raTime){
                toast.error('Time is required')
              }else if(!formData.raAmount){
                toast.error('Amount is required')
              }else if(!formData.raMethod){
                toast.error('Payment method is required')
              }
            return null;
            }
              const updatedData = {
                date: formData.raDate,
                time: formData.raTime,
                gateway: formData.raGateway,
                amount: formData.raAmount,
                method: formData.raMethod,
                transaction: formData.raTransaction,
                comment: formData.raComment,
                checkNo: formData.raCheckNo,
                bankName: formData.raBankName,
                chequeAmount: formData.raChequeAmount,
                chequeDate: formData.raChequeDate,  
                authSignatoryName: formData.raAuthSignatoryName,
              };
        
              setAddReturn([...AddReturn, updatedData]);
              setFormData((prevData) => ({
                ...prevData,
                raDate: '',
                raTime: '',
                raGateway: '',
                raAmount: '',
                raMethod: '',
                raTransaction: '',
                raComment: '',
                raCheckNo: '',
                raBankName: '',
                raChequeAmount: '',
                raChequeDate: '',
                raAuthSignatoryName: '',
                days: '',
              }));
              SubmitHistory('Add Security Amount Return', 'None');
            }
            
            const handleEditRental = (index) => {
              const selectedData = AddRental[index];
            
              setFormData((prevData) => ({
                ...prevData,
                raDate: selectedData.date || '',
                raTime: selectedData.time || '',
                raGateway: selectedData.gateway || '',
                raAmount: selectedData.amount || '',
                raMethod: selectedData.method || '',
                raTransaction: selectedData.transaction || '',
                raComment: selectedData.comment || '',
                raCheckNo: selectedData.checkNo || '',
                raBankName: selectedData.bankName || '',
                raChequeAmount: selectedData.chequeAmount || '',
                raChequeDate: selectedData.chequeDate || '',
                raAuthSignatoryName: selectedData.authSignatoryName || '',
                raindex: index
              }));

            };
        
                
            const handleEditReceived = (index) => {
              const selectedData = AddReceived[index];
            
              setFormData((prevData) => ({
                ...prevData,
                raDate: selectedData.date || '',
                raTime: selectedData.time || '',
                raGateway: selectedData.gateway || '',
                raAmount: selectedData.amount || '',
                raMethod: selectedData.method || '',
                raTransaction: selectedData.transaction || '',
                raComment: selectedData.comment || '',
                raCheckNo: selectedData.checkNo || '',
                raBankName: selectedData.bankName || '',
                raChequeAmount: selectedData.chequeAmount || '',
                raChequeDate: selectedData.chequeDate || '',
                raAuthSignatoryName: selectedData.authSignatoryName || '',
                raindex: index
              }));
            };
        
            const handleEditReturn = (index) => {
              const selectedData = AddReturn[index];
            
              setFormData((prevData) => ({
                ...prevData,
                raDate: selectedData.date || '',
                raTime: selectedData.time || '',
                raGateway: selectedData.gateway || '',
                raAmount: selectedData.amount || '',
                raMethod: selectedData.method || '',
                raTransaction: selectedData.transaction || '',
                raComment: selectedData.comment || '',
                raCheckNo: selectedData.checkNo || '',
                raBankName: selectedData.bankName || '',
                raChequeAmount: selectedData.chequeAmount || '',
                raChequeDate: selectedData.chequeDate || '',
                raAuthSignatoryName: selectedData.authSignatoryName || '',
                raindex: index
              }));
            };
    
  
    const ResetRentalInputs = () => {
      setFormData((prevData) => ({
        ...prevData,
        raDate: '',
        raTime: '',
        raGateway: '',
        raAmount: '',
        raMethod: '',
        raTransaction: '',
        raComment: '',
      }));

    }

  
       const handleUpdateRental = (index) => {
        toast.error('handleUpdateRental')
              if( !formData.raMethod ){
            
                if(!formData.raDate){
                  toast.error('Date is required')
                } else if(!formData.raTime){
                  toast.error('Time is required')
                }else if(!formData.raAmount){
                  toast.error('Amount is required')
                } else if(!formData.raMethod){
                  toast.error('Payment method is required')
                }
              return null;
              }
        
              const updatedData = [...AddRental];
 
               updatedData[index].date = formData.raDate || "NA";
               updatedData[index].time = formData.raTime;
               updatedData[index].gateway = formData.raGateway;
               updatedData[index].amount =  formData.raAmount;
               updatedData[index].method =  formData.raMethod;
               updatedData[index].transaction =  formData.raTransaction || "NA";
               updatedData[index].comment =  formData.raComment; 
               updatedData[index].checkNo =  formData.raCheckNo; 
               updatedData[index].bankName =  formData.raBankName; 
               updatedData[index].chequeAmount =  formData.raChequeAmount; 
               updatedData[index].chequeDate =  formData.raChequeDate; 
               updatedData[index].authSignatoryName =  formData.raAuthSignatoryName; 
               setAddRental(updatedData);
               SubmitHistory('Update Rental Amount'  , 'None');

            }
            
            const handleUpdateReceived = (index) => {
              if( !formData.raMethod ){
            
                if(!formData.raDate){
                  toast.error('Date is required')
                } else if(!formData.raTime){
                  toast.error('Time is required')
                }else if(!formData.raAmount){
                  toast.error('Amount is required')
                }else if(!formData.raMethod){
                  toast.error('Payment method is required')
                }
              return null;
              }
        
              const updatedData = [...AddReceived];
               updatedData[index].days = formData.days;
               updatedData[index].date = formData.raDate;
               updatedData[index].time = formData.raTime;
               updatedData[index].gateway = formData.raGateway;
               updatedData[index].amount =  formData.raAmount;
               updatedData[index].method =  formData.raMethod;
               updatedData[index].transaction =  formData.raTransaction;
               updatedData[index].comment =  formData.raComment; 
               updatedData[index].checkNo =  formData.raCheckNo; 
               updatedData[index].bankName =  formData.raBankName; 
               updatedData[index].chequeAmount =  formData.raChequeAmount; 
               updatedData[index].chequeDate =  formData.raChequeDate; 
               updatedData[index].authSignatoryName =  formData.raAuthSignatoryName; 
               setAddReceived(updatedData);
                SubmitHistory(formData.order === 4 ? 'Update Payment Mangement' : 'Update Security Amount Received'  , 'None');

            }
        
            const handleUpdateReturn = (index) => {
              if( !formData.raMethod ){
            
                if(!formData.raDate){
                  toast.error('Date is required')
                } else if(!formData.raTime){
                  toast.error('Time is required')
                }else if(!formData.raAmount){
                  toast.error('Amount is required')
                }else if(!formData.raMethod){
                  toast.error('Payment method is required')
                }
              return null;
              }
        
              const updatedData = [...AddReturn];
               updatedData[index].date = formData.raDate;
               updatedData[index].time = formData.raTime;
               updatedData[index].gateway = formData.raGateway;
               updatedData[index].amount =  formData.raAmount;
               updatedData[index].method =  formData.raMethod;
               updatedData[index].transaction =  formData.raTransaction;
               updatedData[index].comment =  formData.raComment; 
               updatedData[index].checkNo =  formData.raCheckNo; 
               updatedData[index].bankName =  formData.raBankName; 
               updatedData[index].chequeAmount =  formData.raChequeAmount; 
               updatedData[index].chequeDate =  formData.raChequeDate; 
               updatedData[index].authSignatoryName =  formData.raAuthSignatoryName; 
               setAddReturn(updatedData);
               SubmitHistory('Update Security Amount Return', 'None');

            }



    const handleRemoveRental = (index) => {
      const updatedData = [...AddRental];
      updatedData.splice(index, 1);
      setAddRental(updatedData);
      SubmitHistory('Remove Rental Amount', 'None');

    };


    const handleRemoveReceived = (index) => {
      const updatedData = [...AddReceived];
      updatedData.splice(index, 1);
      setAddReceived(updatedData);
      SubmitHistory('Remove Security Amount Return', 'None');

    };

    const handleRemoveReturn = (index) => {
      const updatedData = [...AddReturn];
      updatedData.splice(index, 1);
      setAddReturn(updatedData);
      SubmitHistory('Remove Security Amount Return', 'None');
    };

    
    const handleRemoveProduct = (index) => {
      const updatedProducts = [...AddProduct];
      updatedProducts.splice(index, 1);
      setAddProduct(updatedProducts);
      SubmitHistory('Remove Product', 'None');
    };
    
    const handleQuantityChange = (index, value) => {
      const updatedProducts = [...AddProduct];
      const quantity = parseInt(value) || 1;
      const price = updatedProducts[index].amount || 0;
      const tax = updatedProducts[index].tax || 0;
    
      updatedProducts[index].quantity = quantity;
      updatedProducts[index].total = quantity * price * (1 + tax / 100);
      setAddProduct(updatedProducts);
      SubmitHistory('Update Product Quantity', 'None');
    };

    const handleSerialNumberChange = (index, value) => {
      const updatedProducts = [...AddProduct];
      const serialNumber = value; 
      updatedProducts[index].serialNumber = serialNumber;
       setAddProduct(updatedProducts);
    };
    
    const handleAmtChange = (index, value) => {
      const updatedProducts = [...AddProduct];
      const newAmount = parseFloat(value) || 0;
      const quantity = updatedProducts[index].quantity || 1;
      const tax = updatedProducts[index].tax || 0;
    
      updatedProducts[index].amount = newAmount;
      updatedProducts[index].total = quantity * newAmount * (1 + tax / 100);
      setAddProduct(updatedProducts);
      SubmitHistory('Update Product Amount', 'None');

    };

    const handleTaxChange = (index, value) => {
      const updatedProducts = [...AddProduct];
      const tax = parseFloat(value) || 0;
      const quantity = updatedProducts[index].quantity || 1;
      const price = updatedProducts[index].amount || 0;
    
      updatedProducts[index].tax = tax;
      updatedProducts[index].total = quantity * price * (1 + tax / 100);
      setAddProduct(updatedProducts);
      SubmitHistory('Update Product Tax', 'None');
    };

      const [searchQuery, setSearchQuery] = useState("");
    
      const handleInputChange = (e) => {
        setSearchQuery(e.target.value);
      };
    
  const [showSearch, setShowSearch] = useState("false");
  const toggleSearch = () => {
    setShowSearch(!showSearch);
  };

  const filteredProducts = AllProducts.filter((item) =>
    item.title.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleUserChange = (userId) => {
     const selectedUser = AllUser.find((user) => user._id === userId);
     console.log('AllUser',userId, AllUser)

    // if (selectedUser) {
    //   setUserDetails({
    //     id: selectedUser._id,
    //     name: selectedUser.username,
    //     email: selectedUser.email,
    //     phone: selectedUser.phone,
    //   });
    //  }

      setCommentStatus(true);
      setCommentEmployee(selectedUser.username);
      setMyComment('Update User');

    //  SubmitHistory('Update User', `username: ${selectedUser.username}`);

  };
  

       const [commentStatus, setCommentStatus] = useState(false);
       const [commentEmployee, setCommentEmployee] = useState(null);
       const [MyComment, setMyComment] = useState('');


  const handleChangeUserComment = () => {
    if(!formData.formcomment || formData.formcomment === '' ){
      toast.error('Please type comment');
    }else{

     SubmitHistory(`Update User | username : ${commentEmployee} `, `${formData.formcomment}`,formData.employeeId);
     setCommentStatus(false);
        setFormData((prevData) => ({
        ...prevData,
        'formcomment': null,
      }));
    }

  }



  const handleChangeComment_old = () => {
    if(!formData.formcomment || formData.formcomment === '' ){
      toast.error('Please type comment');
    }else{

     SubmitHistory(`${MyComment} | username : ${commentEmployee} `, `${formData.formcomment}`,formData.employeeId);
     setCommentStatus(false);
        setFormData((prevData) => ({
        ...prevData,
        'formcomment': null,
      }));
    }

  }

    
      const handleChangeComment = () => {
        if(!formData.formcomment || formData.formcomment === ''  ){
          toast.error('Please type comment');
        }else{
    
          if( !formData.working || formData.working === '' ){
          toast.error('Please Choose Working Status');
          }else{
        if(!formData.workingdate){
          toast.error('Please Choose date');
  return null;
        }
         if(!formData.workingdays){
          toast.error('Please Choose days');
  return null;
        }
      SubmitHistory(`${MyComment} | username : ${commentEmployee} `, `${formData.formcomment} - ${formData.working === '1' && 'working' ||  formData.working === '0'  && 'On leave'  ||  formData.working === '2'  && 'Left job'}`,formData.employeeId,formData.working,formData.working === '2' ? 1 : formData.workingdays ,formData.workingdate);
          
      if (formData.workingdays) {
 
          const pickupDate = new Date(formData.PickupDate);
  const returnDate = new Date(formData.ReturnDate);
  const diffTime = returnDate - pickupDate;
  const diffDays = diffTime / (1000 * 3600 * 24);

  const extraDays = Number(formData.workingdays);
  const totalDays = diffDays + extraDays + 1;

  console.log('Base diffDays: ' + diffDays);
  console.log('Extra days: ' + extraDays);
  console.log('Total days: ' + totalDays);

  const returnValue = addDaysToDate(formData.PickupDate, totalDays);

  setFormData((prevData) => ({
    ...prevData,
    ReturnDate: returnValue,
    diffDays: totalDays,
  }));
  
 
 }

setCommentStatus(false);
            setFormData((prevData) => ({
            ...prevData,
            'formcomment': null,
            'working' : null,
          }));
  
          }
     
        }
    
      }
  
  const handleChange = (e) => {
    const { name, value, type, checked,label  } = e.target;

    let newValue = type === "checkbox" ? checked : value;

    if (name === "slug" ) {
      newValue = value
        .toLowerCase() // Convert to lowercase
        .replace(/\s+/g, "-") // Replace spaces with "-"
        .replace(/[^a-z0-9-]/g, ""); // Remove special characters except "-"
    }else if (name === "employeeSaleId" ) {
      newValue = value;
      SubmitHistory('Update Employee Billing', `username : ${label}`);
    } else if (name === "employeeId" ) {
      newValue = value;
      // SubmitHistory('Update Employee ( Doctor / Nurse / Runner )', `username : ${label}`);
      setCommentStatus(true);
      setCommentEmployee(label);
      setMyComment('Update Employee ( Doctor / Nurse / Runner )');
    } 
    
    if(name === 'PickupDate' &&  formData.diffDays){
   
       const dateValue = newValue;
       const returnvalue =  addDaysToDate(dateValue, formData.diffDays);
       console.log('returnvalue',returnvalue);
       console.log('formData.PickupDate, formData.days',formData.PickupDate, formData.diffDays);
       setFormData((prevData) => ({
        ...prevData,
        'ReturnDate': returnvalue,
      }));
      
    }
    
    if (name === "diffDays" ) {
      let myvalue;
      if(1 > newValue ){
        myvalue = 1
      }else{
        myvalue = newValue;
      }

      setFormData((prevData) => ({
        ...prevData,
        [name]: myvalue,
      }));

if(formData.PickupDate){
  const returnvalue =  addDaysToDate(formData.PickupDate, myvalue);
  console.log('returnvalue',returnvalue);
  console.log('formData.PickupDate, formData.days',formData.PickupDate, formData.days);
  setFormData((prevData) => ({
   ...prevData,
   'ReturnDate': returnvalue,
 }));
}
     
     
    }
 
    else{
      if(name === 'type'){
      SubmitHistory(`Lead Type`, `Change lead type`)
      }
       
          if(name === 'product'){
      SubmitHistory(`Product`, `Change Product to ${newValue}`)
      }
  
     if(name === 'date'){ 
      SubmitHistory(`Follow Up Date`, `Change Follow Up Date`)
      }

         if(name === 'time'){ 
      SubmitHistory(`Follow Up Time`, `Change Follow Up Time`)
      }
       if(name === 'source'){ 
      SubmitHistory(`Lead Source`, `Change Lead Source to ${newValue}`)
      } 
      setFormData((prevData) => ({
        ...prevData,
        [name]: newValue,
      }));
    }
  

   };


  const handleUserDataChange = (e) => {
    const { name, value, type, checked } = e.target;

    let newValue = type === "checkbox" ? checked : value;

    if (name === "slug" ) {
      newValue = value
        .toLowerCase() // Convert to lowercase
        .replace(/\s+/g, "-") // Replace spaces with "-"
        .replace(/[^a-z0-9-]/g, ""); // Remove special characters except "-"
    }

    setUserDetails((prevData) => ({
      ...prevData,
      [name]: newValue,
    }));
  };
  

// const selectUser = async (OrderId, User,cat,type,distance) => {
//   fetchemployeeData(cat,type,distance);
//   setOrderId(OrderId);
//   setUserId(User);
//  }

const fetchUserData = async () => {

  setAllUser([]);
  try {

    const response = await axiosInstance.get(`/all-employee?&type=2&filter=none`);
    const { success, Users } = response.data;
    if (success) {
      console.log('Users',response.data);

      setAllUser(Users);
     }

  } catch (error) {
    console.error('Error fetching User:', error);

  }

};


const fetchSaleEmployeeData = async () => {

  setAllSaleEmployee([]);
  try {
    const response = await axiosInstance.get(`/all-employee?&type=1&filter=2`);
    const { success, Users } = response.data;
    if (success) {
      console.log('Users',response.data);
      setAllSaleEmployee(Users);
     }

  } catch (error) {
    console.error('Error fetching User:', error);

  }

};

const fetchEmployeeData = async (id) => {

  setAllEmployee([]);
  try {
    const response = await axiosInstance.get(`/all-employee?&type=1&filter=${id}`);
    const { success, Users } = response.data;
    if (success) {
      console.log('Users',response.data);
      setAllEmployee(Users);
     }

  } catch (error) {
    console.error('Error fetching User:', error);

  }

};


   const { id } = useParams();
 
   const [IsLoading, setIsLoading] = useState(true);

  const getUserOrders = async () => {
    setIsLoading(true);  

    try {

       const { data } = await axiosInstance.get(`/admin/get-order/${id}`);

      // if (data?.success) {
      //   console.log('order', data)
      //   setOrder(data?.userOrder); 
      // }

console.log('datasetIsLoading ',data)
const myOrder = data?.Order;
if(myOrder){
// console.log('myOrder',myOrder);

setFormData((prevData) => ({
    ...prevData,
    employeeId:myOrder.employeeId,
    AdvanceAmt:myOrder.AdvanceAmt,
    SecurityAmt:myOrder.SecurityAmt,
    OnBoardDate:formatDate(myOrder.OnBoardDate),
    UserId:myOrder.userId,
    type:myOrder.type,
    employeeSaleId:myOrder.employeeSaleId,
        Ldate:myOrder.Ldate,
                Ltime:myOrder.Ltime,
        product:myOrder.product,
        source:myOrder.source,

    // ReturnDate:formatDate(myOrder.ReturnDate),
    // PickupDate:formatDate(myOrder.PickupDate),
    // dutyHr:myOrder.dutyHr,
   employeeSaleId:myOrder.employeeSaleId,
date: myOrder.date,
time: myOrder.time,
comment: myOrder.comment,
requirement: myOrder.requirement,
lead: myOrder.lead,
  })); 

  console.log('formdata', formData.employeeId);

  setUserId(myOrder.userId?._id);
  setDiscount(myOrder.discount);
  setShipping(myOrder.shipping);
  setTaxTotal(myOrder.taxTotal);
  setUserDetails(myOrder.UserDetails ? myOrder.UserDetails[0] : {} );
  setAddProduct(myOrder?.addProduct ? myOrder?.addProduct : {});
  setAddReceived(myOrder?.addReceived ? myOrder?.addReceived : {});
  setAddRental(myOrder?.addRental ? myOrder?.addRental : {} );
  setAddReturn(myOrder?.addReturn ? myOrder?.addReturn : {} );
  setAddHistory(myOrder?.leadHistory ? myOrder?.leadHistory : {} );
  setApplyCGST(myOrder.applyCGST);
  setApplyIGST(myOrder.applyIGST)
  setApplySGST(myOrder.applySGST);
  setSubtotal(myOrder.subtotal);

  setOldHistory( {
      AdvanceAmt : myOrder.AdvanceAmt,
      discount : myOrder.discount,
      SecurityAmt : myOrder.SecurityAmt,
      OnBoardDate : formatDate(myOrder.OnBoardDate),
      order : myOrder.type,
      ReturnDate : formatDate(myOrder.ReturnDate),
      PickupDate : formatDate(myOrder.PickupDate),
      shipping : myOrder.shipping,
      taxTotal : myOrder.taxTotal,
      taxTotal : myOrder.taxTotal,
      UserDetails : myOrder.UserDetails ? myOrder.UserDetails[0] : {} 
    } );

}

    } catch (error) {
     console.log(error);
      toast.error("order Not found");
   
    }finally{
      setIsLoading(false);  
    }
  };

  // useEffect(() => {
  //   console.log('Updated formData', formData.employeeId);

  //   if(formData.diffDays){
  //          setFormData((prevData) => ({
  //       ...prevData,
  //       days: formData.diffDays,
  //     }));
  //    }
  // }, [formData]);
  
  useEffect(() => {
     fetchUserData();
    getUserOrders();
// getUserAllPro();
fetchSaleEmployeeData();
  }, []);

    useEffect(() => {
      setAllEmployee([]);

      // setFormData((prevData) => ({
      //   ...prevData,
      //   employeeId: null,
      // }));

      if(formData.order ){
        if( formData.order !== '2' && formData.order !== 2){
          fetchEmployeeData(formData.order);
        }else{ 
           fetchEmployeeData(1);
        }
      }
     }, [formData.order]);
  
  
  useEffect(() => {
  console.log('UserDetails',UserDetails.length)
  }, []);

  
  useEffect(() => {
    const newSubtotal = AddProduct.reduce((acc, item) => acc + (item.total || 0), 0);
    setSubtotal(newSubtotal);

    let totalTax = 0;

    AddProduct.forEach(item => {
      const baseAmount = item.quantity * item.amount;
      const taxRate = item.tax || 0;

      if (applyIGST) {
        totalTax += baseAmount * (taxRate / 100);
      } else {
        if (applyCGST) totalTax += baseAmount * (taxRate / 100) / 2;
        if (applySGST) totalTax += baseAmount * (taxRate / 100) / 2;
      }
    });

    setTaxTotal(totalTax);

    const calculatedFinalTotal = newSubtotal - discount + shipping ;
    setFinalTotal(calculatedFinalTotal >= 0 ? calculatedFinalTotal : 0);
  }, [AddProduct, discount, shipping, applyIGST, applyCGST, applySGST]);

  useEffect(() => {

  if (formData.PickupDate && formData.ReturnDate) {
    const pickupDate = new Date(formData.PickupDate);
    const returnDate = new Date(formData.ReturnDate);
    const diffTime = returnDate - pickupDate;
    const diffDays = diffTime / (1000 * 3600 * 24); 
    setFormData((prevData) => ({
      ...prevData,
      diffDays:diffDays+1,
    })); 
    }
}, [formData.PickupDate,formData.ReturnDate,AddReceived]);

useEffect(() => {


 

},[formData.AdvanceAmt, discount, formData.SecurityAmt, formData.OnBoardDate, formData.order, formData.ReturnDate,
  formData.PickupDate, shipping, taxTotal ])
  
  const [SubmitLoading, setSubmitLoading] = useState(true); // Add loading state



  const submitData = async () => {
    const mydata = await getDecryptData();
    // toast.error(mydata.empType);

    if( mydata.type !== 0 ){
      if (mydata.empType !== 1 && mydata.empType !== 2){
        toast.error("You don't have access to update this.");
        return null;
      }
    }
    console.log('UserDetails',UserDetails)
 
  
    // Check if UserDetails is an object and has the necessary properties filled
    if (!UserDetails || Object.keys(UserDetails).length === 0 || 
        !UserDetails.name || 
        !UserDetails.phone || 
        !UserDetails.email 
        // || 
        // !UserDetails.gender || !UserDetails.age
      ) {
        
        toast.error('Please Fill in all user details');
        return null;
    }

    
    setSubmitLoading(false);
  
  const now = new Date();
 
  const decryptdatajson = getDecryptData(); 
   
   const updatedFormData = {
      ...formData,
      status: 1,
      employeeId: formData.employeeId,
      userId : UserId,
      UserDetails:UserDetails,
      type : formData.type,
      history : addHistory,
    };

    try {

      await axiosInstance.put(`/admin/update-full-lead/${id}`, updatedFormData);
      console.log('lead Updated successfully!');
      toast.success('lead Updated successfully!');
 
    } catch (error) {
      console.error('Error On Creating lead:', error);
      console.log(formData);
      toast.error(error.response.data.message);
    } finally {
      setSubmitLoading(true);
      getUserOrders();
    }
  };

  const userOptions = AllUser.map(user => ({
    value: user._id,
    label: user.username
  }));
  const employeeSaleOptions = AllSaleEmployee.map(emp => ({
    value: emp._id,
    label: emp.username
  }));

  // Format employee list for react-select
const employeeOptions = AllEmployee.map(emp => ({
  value: emp._id,
  label: emp.username
}));

const SubmitHistory_old = async (changes,comment,id,working,days,date) => {
  const now = new Date();
 
const decryptdatajson = getDecryptData();
      
if(days){
const updatedHistory = { 
  date: date || now.toLocaleDateString(), // e.g., 5/1/2025
  time: now.toLocaleTimeString(), // e.g., 10:10:30 AM
  userId: decryptdatajson._id,
  name: decryptdatajson.username,
  phone: decryptdatajson.phone,
  changes,
  comment,
  assignId : id || null,
  working: working || '',
 };

setAddHistory([...addHistory, updatedHistory]);
console.log('updatedHistoryupdatedHistory',updatedHistory)


}else{
  const updatedHistory = { 
  date: date || now.toLocaleDateString(), // e.g., 5/1/2025
  time: now.toLocaleTimeString(), // e.g., 10:10:30 AM
  userId: decryptdatajson._id,
  name: decryptdatajson.username,
  phone: decryptdatajson.phone,
  changes,
  comment,
  assignId : id || null,
  working: working || '',
 };

setAddHistory([...addHistory, updatedHistory]);
console.log('updatedHistoryupdatedHistory',updatedHistory)


}

}

const SubmitHistory = async (changes, comment, id, working, days, date) => {
  const now = new Date();
  const decryptdatajson = getDecryptData();

  const baseDate = date ? new Date(date) : new Date(); // Use provided date or now
  const dayCount = parseInt(days); // Convert days to number (if possible)

  if (!isNaN(dayCount) && dayCount > 0) {
    // Loop for 'days' number of times
    const newHistories = [];

    for (let i = 0; i < dayCount; i++) {
      const loopDate = new Date(baseDate);
      loopDate.setDate(baseDate.getDate() + i); // Add days

      const updatedHistory = {
        date: loopDate.toLocaleDateString(), // e.g., 5/1/2025
        time: now.toLocaleTimeString(),      // keep time the same
        userId: decryptdatajson._id,
        name: decryptdatajson.username,
        phone: decryptdatajson.phone,
        changes,
        comment,
        assignId: id || null,
        working: working || '',
      };

      newHistories.push(updatedHistory);
    }

    setAddHistory(prev => [...prev, ...newHistories]);
    console.log('Added multiple updatedHistory entries:', newHistories);
  } else {
    // Single entry fallback
    const updatedHistory = {
      date: baseDate.toLocaleDateString(),
      time: now.toLocaleTimeString(),
      userId: decryptdatajson._id,
      name: decryptdatajson.username,
      phone: decryptdatajson.phone,
      changes,
      comment,
      assignId: id || null,
      working: working || '',
    };

    setAddHistory(prev => [...prev, updatedHistory]);
    console.log('Added single updatedHistory:', updatedHistory);
  }
};



function addDaysToDate(dateStr, days) {
  console.log("Input dateStr:", dateStr);
  console.log("Days to add:", days);

  if (!dateStr || isNaN(days)) {
    console.warn("Invalid input to addDaysToDate");
    return "";
  }

  const cleanDateStr = dateStr.split(" ")[0];
  const [year, month, day] = cleanDateStr.split("-").map(Number);
  const date = new Date(year, month - 1, day);
  date.setDate(date.getDate() + Number(days)); // Ensure days is treated as a number

  const result = date.toISOString().split("T")[0];
  console.log("Output date:", result);
  return result;
}

  return (
    <>
     
        <div className="py-4">

{commentStatus && 
    <div
              className="modal fade show"
              id="modal-userr"
              tabIndex={999}
              aria-labelledby="modal-userr"
              style={{ display: "block" ,backgroundColor:'#0000004a'}}
              aria-hidden="true"
            >
              <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                  <div className="modal-body">
   <div className="col-md-12">
                  <label className="mb-2"> Select Working Status</label>

                  <ul className="customradio input-group d-flex gap-2  mb-4 px-0 mx-0">
                    <li>
                      <input
                        type="radio"
                        name="working"
                        onChange={handleChange}
                        value="1"
                        checked={formData.working === "1"}
                      />
                      <label>Working</label>
                    </li>
                    <li>
                      <input
                        type="radio"
                        name="working"
                        onChange={handleChange}
                        value="0"
                        checked={formData.working === "0"}
                      />
                      <label>On Leave  </label>
                    </li>
                    
                  </ul>
                </div>


     <div className='col-md-12'>
 
{formData.working === "0" && 
<>
<div className="mb-4">
   <label htmlFor="workingdate"> Choose Date  <span className='text-danger'> ( Required )</span> </label>

   <input
    type='date'
     className="form-control"
     id="workingdate" value={formData.workingdate}
     name="workingdate" 
     onChange={handleChange}
      />
 </div>
  <div className="mb-4">
   <label htmlFor="workingdays"> No Of Leaves  <span className='text-danger'> ( Required )</span> </label>

   <input
    type='number'
     className="form-control"
     id="workingdays" value={formData.workingdays}
     name="workingdays" 
     onChange={handleChange}
      />
 </div>
</>

}


 <div className="mb-4">
   <label htmlFor="formcomment"> Comment  <span className='text-danger'> ( Required )</span> </label>

   <textarea
  
     className="form-control"
     id="formcomment" value={formData.formcomment}
     name="formcomment" 
     onChange={handleChange}
      />
 </div>
</div>  
 
                  </div>
                  <div className="modal-footer">
                    
                    <button
                      type="button"
                      className="btn btn-gray-300 me-auto"
                      
                      
                      onClick={()=>{setCommentStatus(false)}}
                    >
                      Close
                    </button>

                    <button type="button" class="btn btn-primary ms-auto" onClick={handleChangeComment} > Update Employee </button>

                  </div>
                </div>
              </div>
            </div>

}

 
 

        <div
              className="modal fade"
              id="modal-user"
              tabIndex={-1}
              aria-labelledby="modal-user"
              style={{ display: "none" }}
              aria-hidden="true"
            >
              <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                  <div className="modal-body">


                  <div className="row mb-0">
                      
                  <div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="SecurityAmt"> Client Name <span className='text-danger'>*</span>  </label>

   <input
     type="text"
     className="form-control"
     id="name" value={UserDetails?.name}
     name="name" 
     onChange={handleUserDataChange}
      />
 </div>
</div>                   

<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="SecurityAmt"> Email <span className='text-danger'>*</span>  </label>

   <input
     type="text"
     className="form-control"
     id="email" value={UserDetails?.email}
     name="email" 
     onChange={handleUserDataChange}
      />
 </div>
</div> 

<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="phone"> Phone <span className='text-danger'>*</span>  </label>

   <input
     type="number"
     className="form-control"
     id="phone" value={UserDetails?.phone}
     name="phone" 
     onChange={handleUserDataChange}
      />
 </div>
</div>   

 

<div className="mb-4 col-6 ">
                    <label className="form-label text-dark" htmlFor="email">
                      Gender  <span className="text-danger"> *</span>
                    </label>
                    <div className="input-group    input-sm">
                      <select
                        className="form-control"
                        value={UserDetails?.gender}
                        name="gender"
                        onChange={handleUserDataChange}
                      >
                            <option selected value="">
                          {" "}
                          Select Gender
                        </option>
                        <option value="1">Male</option>
                        <option value="2">Female</option>
                        <option value="0">Other</option>
                      </select>
                    </div>
                  </div>
                  <div className='col-md-6 '>
 
 <div className="mb-4">
   <label htmlFor="Age"> Age   <span className="text-danger"> *</span> </label>

   <input
     type="number"
     className="form-control"
     id="age" value={UserDetails?.age}
     name="age" 
     onChange={handleUserDataChange}
      />
 </div>
</div>  



                  <div className='col-md-6 '>
 
 <div className="mb-4">
   <label htmlFor="Address"> Address  </label>

   <input
     type="text"
     className="form-control"
     id="address" value={UserDetails?.address}
     name="address" 
     onChange={handleUserDataChange}
      />
 </div>
</div>  


 <div className='col-md-6 '>
 
 <div className="mb-4 ">
   <label htmlFor="phone"> Weight  </label>

   <input
     type="text"
     className="form-control"
     id="weight" value={UserDetails?.weight}
     name="weight" 
     onChange={handleUserDataChange}
      />
 </div>
</div>  


<div className='col-md-12'>
 
 <div className="mb-4">
   <label htmlFor="disease"> Disease    </label>
    
   <textarea
     type="text"
     className="form-control"
     id="disease" 
     name="disease" 
     onChange={handleUserDataChange}
     value={UserDetails?.disease}
     />
 </div>
</div>  

                    </div>
                  </div>
                  <div className="modal-footer">
                    
                    <button
                      type="button"
                      className="btn btn-gray-300 ms-auto"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>


            <div
              className="modal fade"
              id="modal-rental"
              tabIndex={-1}
              aria-labelledby="modal-rental"
              style={{ display: "none" }}
              aria-hidden="true"
            >
              <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                  <div className="modal-body">


                  <div className="row mb-0">

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Payment method   <span className='text-danger'>*</span>  </label>

<select
className="form-control select"
id="raMethod" value={formData.raMethod}
name="raMethod" 
onChange={handleChange}
>
<option value=""> Select</option>
<option value="Cash"> Cash</option>
<option value="Cheque"> Cheque </option> 
<option value="Online"> Online </option> 
</select>


</div>
</div>        
              
   { formData.raMethod !== 'Cheque' && <>
     <div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raDate"> Date <span className='text-danger'>*</span>  </label>

<input
type="date"
className="form-control"
id="raDate" value={formData.raDate}
name="raDate" 
onChange={handleChange}
// min={new Date().toISOString().split('T')[0]} // disables past dates

/>
</div>
</div> 

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Time <span className='text-danger'>*</span>  </label>

<input
type="time"
className="form-control"
id="raTime" value={formData.raTime}
name="raTime" 
onChange={handleChange}
/>
</div>
</div> 

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Amount INR <span className='text-danger'>*</span>  </label>

<input
type="text"
className="form-control"
id="raAmount" value={formData.raAmount}
name="raAmount" 
onChange={handleChange}
/>
</div>
</div> 
   </>
   }


{ formData.raMethod === 'Cheque' && <>
<div className='bg-light row px-0 pt-3 m-0 border rounded mb-2'>
<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Cheque No </label>

<input
type="text"
className="form-control"
id="raCheckNo" value={formData.raCheckNo}
name="raCheckNo" 
onChange={handleChange}
/>
</div>
</div> 

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raBankName"> Bank Name </label>

<input
type="text"
className="form-control"
id="raBankName" value={formData.raBankName}
name="raBankName" 
onChange={handleChange}
/>
</div>
</div> 


<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raChequeAmount"> Cheque Amount </label>

<input
type="number"
className="form-control"
id="raChequeAmount" value={formData.raChequeAmount}
name="raChequeAmount" 
onChange={handleChange}
/>
</div>
</div> 

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raChequeDate"> Cheque Date </label>

<input
type="date"
className="form-control"
id="raChequeDate" value={formData.raChequeDate}
name="raChequeDate" 
onChange={handleChange}
// min={new Date().toISOString().split('T')[0]} // disables past dates

/>
</div>
</div> 

<div className='col-md-12'>

<div className="mb-4">
<label htmlFor="raAuthSignatoryName"> Auth Signatory Name {' '} <sup> (Account Holder Name) </sup> </label>

<input
type="text"
className="form-control"
id="raAuthSignatoryName" value={formData.raAuthSignatoryName}
name="raAuthSignatoryName" 
onChange={handleChange}
/> 
</div>
</div> 

</div>
</>

}
{ formData.raMethod === 'Online' &&
<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Transaction Id </label>

<input
type="text"
className="form-control"
id="raTransaction" value={formData.raTransaction}
name="raTransaction" 
onChange={handleChange}
/>
</div>
</div> 
}
<div className='col-md-12'>

<div className="mb-4">
<label htmlFor="raTime"> Comment <span className='text-danger'>*</span>  </label>

<textarea
type="text"
className="form-control"
id="raComment" value={formData.raComment}
name="raComment" 
onChange={handleChange}
/>
</div>
</div>  

     </div>




                  </div>
                  <div className="modal-footer">
                    
                  <button
                      type="button"
                      className="btn btn-gray-300 me-auto"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>

                    <button
                      type="button"
                      className="btn btn-primary ms-auto"
                      data-bs-dismiss="modal"
                      onClick={handleAddRental}
                    >
                      Add
                    </button>
                  </div>
                </div>
              </div>
            </div>


            <div
              className="modal fade"
              id="modal-Received"
              tabIndex={-1}
              aria-labelledby="modal-Received"
              style={{ display: "none" }}
              aria-hidden="true"
            >
              <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                  <div className="modal-body">


                  <div className="row mb-0">

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Payment method   <span className='text-danger'>*</span>  </label>

<select
className="form-control select"
id="raMethod" value={formData.raMethod}
name="raMethod" 
onChange={handleChange}
>
<option value=""> Select</option>
<option value="Cash"> Cash</option>
<option value="Cheque"> Cheque </option> 
<option value="Online"> Online </option> 
</select>


</div>
</div>        
              
   { formData.raMethod !== 'Cheque' && <>
     <div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raDate"> Date <span className='text-danger'>*</span>  </label>

<input
type="date"
className="form-control"
id="raDate" value={formData.raDate}
name="raDate" 
onChange={handleChange}
// min={new Date().toISOString().split('T')[0]} // disables past dates

/>
</div>
</div> 

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Time <span className='text-danger'>*</span>  </label>

<input
type="time"
className="form-control"
id="raTime" value={formData.raTime}
name="raTime" 
onChange={handleChange}
/>
</div>
</div> 

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Amount INR <span className='text-danger'>*</span>  </label>

<input
type="text"
className="form-control"
id="raAmount" value={formData.raAmount}
name="raAmount" 
onChange={handleChange}
/>
</div>
</div> 
   </>
   }

 

{ formData.raMethod === 'Cheque' && <>
<div className='bg-light row px-0 pt-3 m-0 border rounded mb-2'>
<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Cheque No </label>

<input
type="text"
className="form-control"
id="raCheckNo" value={formData.raCheckNo}
name="raCheckNo" 
onChange={handleChange}
/>
</div>
</div> 

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raBankName"> Bank Name </label>

<input
type="text"
className="form-control"
id="raBankName" value={formData.raBankName}
name="raBankName" 
onChange={handleChange}
/>
</div>
</div> 


<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raChequeAmount"> Cheque Amount </label>

<input
type="number"
className="form-control"
id="raChequeAmount" value={formData.raChequeAmount}
name="raChequeAmount" 
onChange={handleChange}
/>
</div>
</div> 

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raChequeDate"> Cheque Date </label>

<input
type="date"
className="form-control"
id="raChequeDate" value={formData.raChequeDate}
name="raChequeDate" 
onChange={handleChange}
// min={new Date().toISOString().split('T')[0]} // disables past dates

/>
</div>
</div> 

<div className='col-md-12'>

<div className="mb-4">
<label htmlFor="raAuthSignatoryName"> Auth Signatory Name {' '} <sup> (Account Holder Name) </sup> </label>

<input
type="text"
className="form-control"
id="raAuthSignatoryName" value={formData.raAuthSignatoryName}
name="raAuthSignatoryName" 
onChange={handleChange}
/> 
</div>
</div> 

</div>
</>

}
{ formData.raMethod === 'Online' &&
<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Transaction Id </label>

<input
type="text"
className="form-control"
id="raTransaction" value={formData.raTransaction}
name="raTransaction" 
onChange={handleChange}
/>
</div>
</div> 
}

 {formData.order === 4 && 
<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raTime"> No. of days <span className='text-danger'>*</span>  </label>

   <input
     type="number"
     className="form-control"
     id="days" value={formData.days}
     name="days" 
     onChange={handleChange}
      />
 </div>
</div> 
}

<div className='col-md-12'>

<div className="mb-4">
<label htmlFor="raTime"> Comment <span className='text-danger'>*</span>  </label>

<textarea
type="text"
className="form-control"
id="raComment" value={formData.raComment}
name="raComment" 
onChange={handleChange}
/>
</div>
</div>  

     </div>


                  </div>
                  <div className="modal-footer">
                    
                  <button
                      type="button"
                      className="btn btn-gray-300 me-auto"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>

                    <button
                      type="button"
                      className="btn btn-primary ms-auto"
                      data-bs-dismiss="modal"
                      onClick={handleAddReceived}
                    >
                      Add
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="modal fade"
              id="modal-Return"
              tabIndex={-1}
              aria-labelledby="modal-Return"
              style={{ display: "none" }}
              aria-hidden="true"
            >
              <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                  <div className="modal-body">

 
                 
                  <div className="row mb-0">

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Payment method   <span className='text-danger'>*</span>  </label>

<select
className="form-control select"
id="raMethod" value={formData.raMethod}
name="raMethod" 
onChange={handleChange}
>
<option value=""> Select</option>
<option value="Cash"> Cash</option>
<option value="Cheque"> Cheque </option> 
<option value="Online"> Online </option> 
</select>


</div>
</div>        
              
   { formData.raMethod !== 'Cheque' && <>
     <div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raDate"> Date <span className='text-danger'>*</span>  </label>

<input
type="date"
className="form-control"
id="raDate" value={formData.raDate}
name="raDate" 
onChange={handleChange}
// min={new Date().toISOString().split('T')[0]} // disables past dates

/>
</div>
</div> 

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Time <span className='text-danger'>*</span>  </label>

<input
type="time"
className="form-control"
id="raTime" value={formData.raTime}
name="raTime" 
onChange={handleChange}
/>
</div>
</div> 

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Amount INR <span className='text-danger'>*</span>  </label>

<input
type="text"
className="form-control"
id="raAmount" value={formData.raAmount}
name="raAmount" 
onChange={handleChange}
/>
</div>
</div> 
   </>
   }


{ formData.raMethod === 'Cheque' && <>
<div className='bg-light row px-0 pt-3 m-0 border rounded mb-2'>
<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Cheque No </label>

<input
type="text"
className="form-control"
id="raCheckNo" value={formData.raCheckNo}
name="raCheckNo" 
onChange={handleChange}
/>
</div>
</div> 

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raBankName"> Bank Name </label>

<input
type="text"
className="form-control"
id="raBankName" value={formData.raBankName}
name="raBankName" 
onChange={handleChange}
/>
</div>
</div> 


<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raChequeAmount"> Cheque Amount </label>

<input
type="number"
className="form-control"
id="raChequeAmount" value={formData.raChequeAmount}
name="raChequeAmount" 
onChange={handleChange}
/>
</div>
</div> 

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raChequeDate"> Cheque Date </label>

<input
type="date"
className="form-control"
id="raChequeDate" value={formData.raChequeDate}
name="raChequeDate" 
onChange={handleChange}
// min={new Date().toISOString().split('T')[0]} // disables past dates

/>
</div>
</div> 

<div className='col-md-12'>

<div className="mb-4">
<label htmlFor="raAuthSignatoryName"> Auth Signatory Name {' '} <sup> (Account Holder Name) </sup> </label>

<input
type="text"
className="form-control"
id="raAuthSignatoryName" value={formData.raAuthSignatoryName}
name="raAuthSignatoryName" 
onChange={handleChange}
/> 
</div>
</div> 

</div>
</>

}
{ formData.raMethod === 'Online' &&
<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Transaction Id </label>

<input
type="text"
className="form-control"
id="raTransaction" value={formData.raTransaction}
name="raTransaction" 
onChange={handleChange}
/>
</div>
</div> 
}
<div className='col-md-12'>

<div className="mb-4">
<label htmlFor="raTime"> Comment <span className='text-danger'>*</span>  </label>

<textarea
type="text"
className="form-control"
id="raComment" value={formData.raComment}
name="raComment" 
onChange={handleChange}
/>
</div>
</div>  

     </div>




                  </div>
                  <div className="modal-footer">
                    
                  <button
                      type="button"
                      className="btn btn-gray-300 me-auto"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>

                    <button
                      type="button"
                      className="btn btn-primary ms-auto"
                      data-bs-dismiss="modal"
                      onClick={handleAddReturn}
                    >
                      Add Return
                    </button>
                  </div>
                </div>
              </div>
            </div>



            <div
              className="modal fade"
              id="modal-edit-rental"
              tabIndex={-1}
              aria-labelledby="modal-edit-rental"
              style={{ display: "none" }}
              aria-hidden="true"
            >
              <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                  <div className="modal-body">

 
                  <div className="row mb-0">

               <div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raTime"> Payment method   <span className='text-danger'>*</span>  </label>
 
<select
  className="form-control select"
  id="raMethod" value={formData.raMethod}
     name="raMethod" 
     onChange={handleChange}
>
<option value=""> Select</option>
  <option value="Cash"> Cash</option>
   <option value="Cheque"> Cheque </option> 
   <option value="Online"> Online </option> 
</select>


 </div>
</div>        
                             
                  { formData.raMethod !== 'Cheque' && <>
                    <div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raDate"> Date <span className='text-danger'>*</span>  </label>

   <input
     type="date"
     className="form-control"
     id="raDate" value={formData.raDate}
     name="raDate" 
     onChange={handleChange}
    //  min={new Date().toISOString().split('T')[0]} // disables past dates

      />
 </div>
</div> 
 
<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raTime"> Time <span className='text-danger'>*</span>  </label>

   <input
     type="time"
     className="form-control"
     id="raTime" value={formData.raTime}
     name="raTime" 
     onChange={handleChange}
      />
 </div>
</div> 

<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raTime"> Amount INR <span className='text-danger'>*</span>  </label>

   <input
     type="text"
     className="form-control"
     id="raAmount" value={formData.raAmount}
     name="raAmount" 
     onChange={handleChange}
      />
 </div>
</div> 
                  </>
                  }


{ formData.raMethod === 'Cheque' && <>
<div className='bg-light row px-0 pt-3 m-0 border rounded mb-2'>
  <div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raTime"> Cheque No </label>

   <input
     type="text"
     className="form-control"
     id="raCheckNo" value={formData.raCheckNo}
     name="raCheckNo" 
     onChange={handleChange}
      />
 </div>
</div> 

<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raBankName"> Bank Name </label>

   <input
     type="text"
     className="form-control"
     id="raBankName" value={formData.raBankName}
     name="raBankName" 
     onChange={handleChange}
      />
 </div>
</div> 


<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raChequeAmount"> Cheque Amount </label>

   <input
     type="number"
     className="form-control"
     id="raChequeAmount" value={formData.raChequeAmount}
     name="raChequeAmount" 
     onChange={handleChange}
      />
 </div>
</div> 


<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raChequeDate"> Cheque Date </label>

   <input
     type="date"
     className="form-control"
     id="raChequeDate" value={formData.raChequeDate}
     name="raChequeDate" 
     onChange={handleChange}
    //  min={new Date().toISOString().split('T')[0]} // disables past dates

      />
 </div>
</div> 

<div className='col-md-12'>
 
 <div className="mb-4">
   <label htmlFor="raAuthSignatoryName"> Auth Signatory Name {' '} <sup> (Account Holder Name) </sup> </label>

   <input
     type="text"
     className="form-control"
     id="raAuthSignatoryName" value={formData.raAuthSignatoryName}
     name="raAuthSignatoryName" 
     onChange={handleChange}
      /> 
 </div>
</div> 

</div>
</>

}

 
 {formData.order === 4 && 
<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raTime"> No. of days <span className='text-danger'>*</span>  </label>

   <input
     type="number"
     className="form-control"
     id="days" value={formData.days}
     name="days" 
     onChange={handleChange}
      />
 </div>
</div> 
}
   
{ formData.raMethod === 'Online' &&
<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raTime"> Transaction Id </label>

   <input
     type="text"
     className="form-control"
     id="raTransaction" value={formData.raTransaction}
     name="raTransaction" 
     onChange={handleChange}
      />
 </div>
</div> 
}
<div className='col-md-12'>
 
 <div className="mb-4">
   <label htmlFor="raTime"> Comment <span className='text-danger'>*</span>  </label>

   <textarea
     type="text"
     className="form-control"
     id="raComment" value={formData.raComment}
     name="raComment" 
     onChange={handleChange}
      />
 </div>
</div>  

                    </div>





                  </div>
                  <div className="modal-footer">
                    
                  <button
                      type="button"
                      className="btn btn-gray-300 me-auto"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>

                    <button
                      type="button"
                      className="btn btn-primary ms-auto"
                      data-bs-dismiss="modal"
                      onClick={()=>handleUpdateRental(formData.raindex)}
                    >
                      Update
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="modal fade"
              id="modal-edit-Received"
              tabIndex={-1}
              aria-labelledby="modal-edit-Received"
              style={{ display: "none" }}
              aria-hidden="true"
            >
              <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                  <div className="modal-body">


                  <div className="row mb-0">

               <div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raTime"> Payment method   <span className='text-danger'>*</span>  </label>
 
<select
  className="form-control select"
  id="raMethod" value={formData.raMethod}
     name="raMethod" 
     onChange={handleChange}
>
<option value=""> Select</option>
  <option value="Cash"> Cash</option>
   <option value="Cheque"> Cheque </option> 
   <option value="Online"> Online </option> 
</select>


 </div>
</div>        
                             
                  { formData.raMethod !== 'Cheque' && <>
                    <div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raDate"> Date <span className='text-danger'>*</span>  </label>

   <input
     type="date"
     className="form-control"
     id="raDate" value={formData.raDate}
     name="raDate" 
     onChange={handleChange}
    //  min={new Date().toISOString().split('T')[0]} // disables past dates

      />
 </div>
</div> 
 
<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raTime"> Time <span className='text-danger'>*</span>  </label>

   <input
     type="time"
     className="form-control"
     id="raTime" value={formData.raTime}
     name="raTime" 
     onChange={handleChange}
      />
 </div>
</div> 

<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raTime"> Amount INR <span className='text-danger'>*</span>  </label>

   <input
     type="text"
     className="form-control"
     id="raAmount" value={formData.raAmount}
     name="raAmount" 
     onChange={handleChange}
      />
 </div>
</div> 
                  </>
                  }


{ formData.raMethod === 'Cheque' && <>
<div className='bg-light row px-0 pt-3 m-0 border rounded mb-2'>
  <div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raTime"> Cheque No </label>

   <input
     type="text"
     className="form-control"
     id="raCheckNo" value={formData.raCheckNo}
     name="raCheckNo" 
     onChange={handleChange}
      />
 </div>
</div> 

<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raBankName"> Bank Name </label>

   <input
     type="text"
     className="form-control"
     id="raBankName" value={formData.raBankName}
     name="raBankName" 
     onChange={handleChange}
      />
 </div>
</div> 


<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raChequeAmount"> Cheque Amount </label>

   <input
     type="number"
     className="form-control"
     id="raChequeAmount" value={formData.raChequeAmount}
     name="raChequeAmount" 
     onChange={handleChange}
      />
 </div>
</div> 

<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raChequeDate"> Cheque Date </label>

   <input
     type="date"
     className="form-control"
     id="raChequeDate" value={formData.raChequeDate}
     name="raChequeDate" 
     onChange={handleChange}
    //  min={new Date().toISOString().split('T')[0]} // disables past dates

      />
 </div>
</div> 

<div className='col-md-12'>
 
 <div className="mb-4">
   <label htmlFor="raAuthSignatoryName"> Auth Signatory Name {' '} <sup> (Account Holder Name) </sup> </label>

   <input
     type="text"
     className="form-control"
     id="raAuthSignatoryName" value={formData.raAuthSignatoryName}
     name="raAuthSignatoryName" 
     onChange={handleChange}
      /> 
 </div>
</div> 

</div>
</>

}
{ formData.raMethod === 'Online' &&
<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raTime"> Transaction Id </label>

   <input
     type="text"
     className="form-control"
     id="raTransaction" value={formData.raTransaction}
     name="raTransaction" 
     onChange={handleChange}
      />
 </div>
</div> 
}


 {formData.order === 4 && 
<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raTime"> No. of days <span className='text-danger'>*</span>  </label>

   <input
     type="number"
     className="form-control"
     id="days" value={formData.days}
     name="days" 
     onChange={handleChange}
      />
 </div>
</div> 
}

<div className='col-md-12'>
 
 <div className="mb-4">
   <label htmlFor="raTime"> Comment <span className='text-danger'>*</span>  </label>

   <textarea
     type="text"
     className="form-control"
     id="raComment" value={formData.raComment}
     name="raComment" 
     onChange={handleChange}
      />
 </div>
</div>  

                    </div>



                  </div>
                  <div className="modal-footer">
                    
                  <button
                      type="button"
                      className="btn btn-gray-300 me-auto"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>

                    <button
                      type="button"
                      className="btn btn-primary ms-auto"
                      data-bs-dismiss="modal"
                      onClick={()=>handleUpdateReceived(formData.raindex)}
                    >
                      Update Security
                    </button>
                  </div>
                </div>
              </div>
            </div>


            <div
              className="modal fade"
              id="modal-edit-Return"
              tabIndex={-1}
              aria-labelledby="modal-edit-Return"
              style={{ display: "none" }}
              aria-hidden="true"
            >
              <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                  <div className="modal-body">


                  <div className="row mb-0">

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Payment method   <span className='text-danger'>*</span>  </label>

<select
className="form-control select"
id="raMethod" value={formData.raMethod}
name="raMethod" 
onChange={handleChange}
>
<option value=""> Select</option>
<option value="Cash"> Cash</option>
<option value="Cheque"> Cheque </option> 
<option value="Online"> Online </option> 
</select>


</div>
</div>        
              
   { formData.raMethod !== 'Cheque' && <>
     <div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raDate"> Date <span className='text-danger'>*</span>  </label>

<input
type="date"
className="form-control"
id="raDate" value={formData.raDate}
name="raDate" 
onChange={handleChange}
// min={new Date().toISOString().split('T')[0]} // disables past dates

/>
</div>
</div> 

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Time <span className='text-danger'>*</span>  </label>

<input
type="time"
className="form-control"
id="raTime" value={formData.raTime}
name="raTime" 
onChange={handleChange}
/>
</div>
</div> 

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Amount INR <span className='text-danger'>*</span>  </label>

<input
type="text"
className="form-control"
id="raAmount" value={formData.raAmount}
name="raAmount" 
onChange={handleChange}
/>
</div>
</div> 
   </>
   }


{ formData.raMethod === 'Cheque' && <>
<div className='bg-light row px-0 pt-3 m-0 border rounded mb-2'>
<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Cheque No </label>

<input
type="text"
className="form-control"
id="raCheckNo" value={formData.raCheckNo}
name="raCheckNo" 
onChange={handleChange}
/>
</div>
</div> 

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raBankName"> Bank Name </label>

<input
type="text"
className="form-control"
id="raBankName" value={formData.raBankName}
name="raBankName" 
onChange={handleChange}
/>
</div>
</div> 


<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raChequeAmount"> Cheque Amount </label>

<input
type="number"
className="form-control"
id="raChequeAmount" value={formData.raChequeAmount}
name="raChequeAmount" 
onChange={handleChange}
/>
</div>
</div> 

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raChequeDate"> Cheque Date </label>

<input
type="date"
className="form-control"
id="raChequeDate" value={formData.raChequeDate}
name="raChequeDate" 
onChange={handleChange}
// min={new Date().toISOString().split('T')[0]} // disables past dates

/>
</div>
</div> 

<div className='col-md-12'>

<div className="mb-4">
<label htmlFor="raAuthSignatoryName"> Auth Signatory Name {' '} <sup> (Account Holder Name) </sup> </label>

<input
type="text"
className="form-control"
id="raAuthSignatoryName" value={formData.raAuthSignatoryName}
name="raAuthSignatoryName" 
onChange={handleChange}
/> 
</div>
</div> 

</div>
</>

}
{ formData.raMethod === 'Online' &&
<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Transaction Id </label>

<input
type="text"
className="form-control"
id="raTransaction" value={formData.raTransaction}
name="raTransaction" 
onChange={handleChange}
/>
</div>
</div> 
}
<div className='col-md-12'>

<div className="mb-4">
<label htmlFor="raTime"> Comment <span className='text-danger'>*</span>  </label>

<textarea
type="text"
className="form-control"
id="raComment" value={formData.raComment}
name="raComment" 
onChange={handleChange}
/>
</div>
</div>  

     </div>



                  </div>
                  <div className="modal-footer">
                    
                  <button
                      type="button"
                      className="btn btn-gray-300 me-auto"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>

                    <button
                      type="button"
                      className="btn btn-primary ms-auto"
                      data-bs-dismiss="modal"
                      onClick={()=>handleUpdateReturn(formData.raindex)}
                    >
                      Update Return
                    </button>
                  </div>
                </div>
              </div>
            </div>

{!IsLoading ? 

<div className='bg-white p-0'>
{/* <h4> {formData.lead !== 1 ? 'Lead Edit': 'Lead View'}  </h4> */}
<hr className='my-1 p-0'/>


<div className='row mt-4 px-3'>

 
 <div className="mb-4 d-none">
 <div className='col-md-4'>

 <label htmlFor="eventTitle">
                     
                     Lead Type 
                   </label>{" "}

                   <select
                     className="form-control select"
                     name="type"
                     style={{ width: "100%" }} 
                      value={formData.type}
                      onChange={handleChange}
                      disabled={formData.lead === 1}
                   >
                     <option disabled selected> Select type</option>
                     <option value={1} > Order</option>
                     <option value={2} > Rental </option>
                     <option value={3} > Doctors appointment </option>
                     <option value={4} > Nurse </option> 
                     </select>

 </div> 
     </div>
 

<div className="mb-4 d-none">
<div className='col-md-4'>

<label htmlFor="eventTitle">
                    
                    Order Type
                  </label>{" "}

                  <select
                    className="form-control select"
                    name="order"
                    style={{ width: "100%" }} 
                     value={formData.order}
                 onChange={handleChange}
                  >
                    <option > Select type</option>
                    <option value={1} > Order</option>
                    <option value={2} > Rental </option>
                    <option value={3} > Doctors appointment </option>
                    <option value={4} > Nurse </option>

                    </select>

</div>
                   
                      </div>
                     


<div className="row mb-0 bg-light p-2 pt-3 mx-0 border rounded mb-2 d-none">
                      
<div className='col-md-6'>
     
     <div className="mb-4">
       <label htmlFor="phone"> Phones <span className='text-danger'>*</span>  </label>
    
       <input
         type="number"
         className="form-control"
         id="phone" value={UserDetails.phone}
         name="phone" 
         maxLength="10"
      onChange={(e) => {
    const value = e.target.value;
    // Allow only digits and up to 10 characters
    if (/^\d{0,10}$/.test(value)) {
      handleUserDataChange(e);
    }
  }}
         onWheel={(e) => e.target.blur()} // Use a function to handle the wheel event
         onKeyDown={(e) => {
           if (
             e.key === "ArrowUp" ||
             e.key === "ArrowDown"
           ) {
             e.preventDefault(); // Prevent the default action for up/down keys
           }
         }}
           disabled={formData.lead === 1}
         
          />
     </div>
    </div>   
    

                      <div className='col-md-6'>
                 

     <div className="mb-4">
       <label htmlFor="SecurityAmt"> Client Name <span className='text-danger'>*</span>  </label>
    
       <input
         type="text"
         className="form-control"
         id="name" value={UserDetails.name}
         name="name" 
         onChange={handleUserDataChange}
         disabled={formData.lead === 1}
          />
     </div>
    </div>                   
    
    <div className='col-md-3'>
     
     <div className="mb-4">
       <label htmlFor="SecurityAmt"> Email <span className='text-danger'>*</span>  </label>
    
       <input
         type="text"
         className="form-control"
         id="email" value={UserDetails.email}
         name="email" 
         onChange={handleUserDataChange}
         disabled={formData.lead === 1}
          />
     </div>
    </div> 
    
    <div className='col-md-3 d-none'>
 
 <div className="mb-4">
   <label htmlFor="SecurityAmt"> Age <span className='text-danger'>*</span>  </label>

   <input
     type="text"
     className="form-control"
     id="age" value={UserDetails.age}
     disabled={formData.lead === 1}
     name="age" 
     onChange={handleUserDataChange}
      />
 </div>
</div>  
     
        
     <div className='col-md-3 d-none'>
     
     <div className="mb-4 ">
       <label htmlFor="phone"> Weight  </label>
    
       <input
         type="text"
         className="form-control"
         id="weight" value={UserDetails.weight}
         name="weight" 
         onChange={handleUserDataChange}
         disabled={formData.lead === 1}
          />
     </div>
    </div>  
    
    
    <div className="mb-4 col-md-3 d-none">
                        <label className="form-label text-dark" htmlFor="email">
                          Gender  <span className="text-danger"> *</span>
                        </label>
                        <div className="input-group    input-sm">
                          <select
                            className="form-control"
                            value={UserDetails.gender}
                            disabled={formData.lead === 1}
                            name="gender"
                            onChange={handleUserDataChange}
                          >
                            <option selected disabled>
                              {" "}
                              Select Gender
                            </option>
                            <option value="1">Male</option>
                            <option value="2">Female</option>
                            <option value="0">Other</option>
                          </select>
                        </div>
                      </div>
    
      <div className="mb-4 col-md-3 ">
                        <label className="form-label text-dark" htmlFor="email">
                          Do you have Company ? 
                        </label>
                        <div className="input-group    input-sm">
                          <select
                            className="form-control"
                            value={UserDetails.company}
                            disabled={formData.lead === 1}
                            name="company"
                            onChange={handleUserDataChange}
                          >
                            
                            <option value="yes">Yes</option>
                            <option value="no" selected>NO</option>
                           </select>
                        </div>
                      </div>
                     
                      {UserDetails.company === 'yes' && <>
 
                      <div className='col-md-12'/>
                      <div className='col-md-4'>
     
     <div className="mb-4">
       <label htmlFor="companyName"> Company Name  </label>
    
       <input
         type="text"
         className="form-control"
         id="companyName" value={UserDetails.companyName}
         disabled={formData.lead === 1}
         name="companyName" 
         onChange={handleUserDataChange}
          />
     </div>
    </div>  
    
    <div className='col-md-4'>
     
     <div className="mb-4">
       <label htmlFor="companyGST"> Company GST  </label>
    
       <input
         type="text"
         className="form-control"
         id="companyGST" value={UserDetails.companyGST}
         disabled={formData.lead === 1}
         name="companyGST" 
         onChange={handleUserDataChange}
          />
     </div>
    </div>  
    
        <div className='col-md-4'>
     
     <div className="mb-4">
       <label htmlFor="companyGST"> Company Address  </label>
    
       <input
         type="text"
         className="form-control"
         id="companyAddress" value={UserDetails.companyAddress}
         disabled={formData.lead === 1}
         name="companyAddress" 
         onChange={handleUserDataChange}
          />
     </div>
    </div> 


                      </>}
    
                      <div className='col-md-12'>
     
     <div className="mb-4">
       <label htmlFor="Address"> Address  </label>
    
       <textarea
         type="text"
         className="form-control"
         id="address" value={UserDetails.address}
         disabled={formData.lead === 1}
         name="address" 
         onChange={handleUserDataChange}
          />
     </div>
    </div>  
    
 
    
    <div className='col-md-12'>
     
     <div className="mb-4">
       <label htmlFor="disease"> Disease    </label>
    
       <textarea
         type="text"
         className="form-control"
         id="disease" 
         name="disease" 
         onChange={handleUserDataChange}
         disabled={formData.lead === 1}
          >{UserDetails.disease}</textarea>
     </div>
    </div>  
    
                        </div>
 

   <div className='col-md-4 mb-4 d-none'>

 <label htmlFor="eventTitle">
                     
                  Follow-up
                   </label>{" "}

                   <select
                     className="form-control select"
                     name="follow"
                     style={{ width: "100%" }} 
                     value={formData.follow}
                     disabled={formData.lead === 1}
                     onChange={handleChange}
                   >
                     <option disabled selected> Select type</option>
                     <option value={1} > Order</option>
                     <option value={2} > Rental </option>
                     <option value={3} > Doctors appointment </option>
                     <option value={4} > Nurse </option>
                   </select>

 </div> 
 
<div className='col-12'/>  
 
                          <div className='col-md-6 d-none'>
 
                  
 <div className="mb-4">
<label htmlFor="eventTitle">

Choose Employee ( Sales )
</label>{" "}

<Select
    name="employeeSaleId"
    className="basic-single w-100"
    classNamePrefix="select"
    options={employeeSaleOptions}
    value={employeeSaleOptions.find(option => option.value === formData.employeeSaleId)}
 
onChange={(selectedOption) => {
  if (formData.lead !== 1) {
    const event = {
      target: {
        name: 'employeeSaleId',
        value: selectedOption.value,
          label: selectedOption.label
      }
    };
    handleChange(event); // Reuse your existing handleChange logic
  }
}}

    placeholder="Select Employee"
    isSearchable
  />

</div>

</div>

 
  
 
  <div className='col-md-6 mb-4 d-none'>
    <label htmlFor="product">Lead Product</label>

    <select
      className="form-control select"
      name="product"
      style={{ width: "100%" }}
      value={formData.product}
       disabled={formData.lead === 1}
      onChange={handleChange}
      id="product"
    >
      <option disabled value="">Select Product</option>
      {Lpro.map((item) => (
        <option key={item.id} value={item.name}>
          {item.name}
        </option>
      ))}
    </select>
  </div>
 


 <div className='col-md-6 mb-4 '>

 <label htmlFor="eventDate">
                     
                  Follow Up Date
                   </label> 
<input className="form-control"  id="eventDate"  type='date' value={formData.date ? new Date(formData.date).toISOString().slice(0, 10) : ''}
  name="date" onChange={handleChange}  disabled={formData.lead === 1} />
    

 </div> 

  <div className='col-md-6 mb-4'>

 <label htmlFor="eventTime">
                     
                  Follow Up Time
                   </label> 
<input className="form-control" id="eventTime"  disabled={formData.lead === 1} type='time' value={formData.time}  name="time" onChange={handleChange} /> 

 </div> 

  
 <div className='col-md-6 mb-4 d-none'>

 <label htmlFor="eventSource">
                     
                     Lead Source 
                   </label>{" "}

                 <select
  className="form-control select"
  name="source"
  style={{ width: "100%" }}
  value={formData.source}
  onChange={handleChange}
   disabled={formData.lead === 1}
  id="eventSource" >
  <option selected value="">Select Source</option>
  <option value="Google Ads">Google Ads</option>
  <option value="Meta Ads">Meta Ads</option>
  <option value="Website Admin">Website Admin</option>
  <option value="Cold Call">Cold Call</option>
  <option value="Whatsapp">Whatsapp</option>
  <option value="Old Client Reference">Old Client Reference</option>
  <option value="Employee Referral">Employee Referral</option>
  <option value="Online Store">Online Store</option>
  <option value="Email">Email</option>
  <option value="Other">Other</option>
  <option value="Justdial">Justdial</option>
  <option value="Direct">Direct</option>
</select>


 </div> 


  <div className='col-md-6 mb-4 d-none'>

 <label htmlFor="eventComment"> Comment </label> 
<textarea className="form-control" id="eventComment"   disabled={formData.lead === 1} value={formData.comment}  name="comment" onChange={handleChange} /> 
 
 </div> 

 
  <div className='col-md-6 mb-4 d-none'>

 <label htmlFor="eventRequirement"> Requirement </label> 
<textarea className="form-control"
 id="eventRequirement"  disabled={formData.lead === 1} value={formData.requirement}  name="requirement"
 onChange={handleChange} /> 
 
 </div> 

<div className='col-md-12 my-4 d-none'>
<div className='d-flex justify-content-between'>
<h4>History
</h4>
 </div>
<hr/>

<div className='overflow-auto'>
<table className="table table-bordered mt-3">
<thead>
  <tr>
    <th>#</th>
     <th>Date</th>
    <th>Time</th>
    <th>User details</th>
    <th> Changes </th>
    <th> Commnent </th>
 
  </tr>
</thead>
<tbody>
  {addHistory.length > 0 ? (
    addHistory.map((data, index) => (
      <tr key={index}>
        <td>{index + 1}</td>
         <td>{data.date}</td>
         <td>{data.time}</td>
         <td>Username: {data.name}  
         </td>
          <td>{data.changes}</td>
         <td>{data.comment }</td>
          
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="8" className="text-center">No History Found</td>
    </tr>
  )}
</tbody>
</table>
</div>
 

</div>


<div className="col-12 mt-2">

{!IsLoading ? (
 formData.lead !== 1 && 
<button className="btn btn-secondary" type="button" onClick={submitData}  >
  Update Lead
</button>
) : (

<button class="btn btn-secondary btn-sm" type="button" disabled>
  <span class="ms-1">Loading...</span>
  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
</button>

)}


</div>



    </div>

</div>
 
 : <div className='h-100 vh-100 d-flex justify-content-center align-items-center'>
  <div class="spinner-border" role="status" style={{width:100,height:100}}></div>
 </div>
}

 </div>
 
      
    </>
  )
}

export default LeadEditShort